import type { SelectOption } from 'contracts/Common';

const DOCUMENT_TYPES: SelectOption[] = [
  {
    value: 'cnpj',
    label: 'Pessoa Jurídica',
  },
  {
    value: 'cpf',
    label: 'Pessoa Física',
  },
  {
    value: 'other',
    label: 'Estrangeiro',
  },
];

const STATES: SelectOption[] = [
  {
    value: 'AC',
    label: 'Acre',
  },
  {
    value: 'AL',
    label: 'Alagoas',
  },
  {
    value: 'AP',
    label: 'Amapá',
  },
  {
    value: 'AM',
    label: 'Amazonas',
  },
  {
    value: 'BA',
    label: 'Bahia',
  },
  {
    value: 'CE',
    label: 'Ceará',
  },
  {
    value: 'DF',
    label: 'Distrito Federal',
  },
  {
    value: 'ES',
    label: 'Espírito Santo',
  },
  {
    value: 'GO',
    label: 'Goiás',
  },
  {
    value: 'MA',
    label: 'Maranhão',
  },
  {
    value: 'MT',
    label: 'Mato Grosso',
  },
  {
    value: 'MS',
    label: 'Mato Grosso do Sul',
  },
  {
    value: 'MG',
    label: 'Minas Gerais',
  },
  {
    value: 'PA',
    label: 'Pará',
  },
  {
    value: 'PB',
    label: 'Paraíba',
  },
  {
    value: 'PR',
    label: 'Paraná',
  },
  {
    value: 'PE',
    label: 'Pernambuco',
  },
  {
    value: 'PI',
    label: 'Piauí',
  },
  {
    value: 'RJ',
    label: 'Rio de Janeiro',
  },
  {
    value: 'RN',
    label: 'Rio Grande do Norte',
  },
  {
    value: 'RS',
    label: 'Rio Grande do Sul',
  },
  {
    value: 'RO',
    label: 'Rondônia',
  },
  {
    value: 'RR',
    label: 'Roraima',
  },
  {
    value: 'SC',
    label: 'Santa Catarina',
  },
  {
    value: 'SP',
    label: 'São Paulo',
  },
  {
    value: 'SE',
    label: 'Sergipe',
  },
  {
    value: 'TO',
    label: 'Tocantins',
  },
];

const CATEGORY: SelectOption[] = [
  {
    value: 'MANUAL',
    label: 'MANUAL',
  },
  {
    value: 'PROCEDIMENTO',
    label: 'PROCEDIMENTO',
  },
  {
    value: 'CONTATOS',
    label: 'CONTATOS',
  },
];

// Tipo do radar do FIDS: o tipo 2 tem anéis maiores (veículos pesados).
const FIDS_RING_TYPES: SelectOption[] = [
  { value: 1, label: 'Tipo 1' },
  { value: 2, label: 'Tipo 2' },
];

export const SELECT_OPTIONS = {
  DOCUMENT_TYPES,
  FIDS_RING_TYPES,
  STATES,
  CATEGORY,
};
